import { Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { Button } from 'src/chrome'

import styles from './uiCard.module.scss'
import { ButtonColorChoices } from 'src/theme/buttonColors'

interface UICardAction {
  id?: string
  title: string
  gradient?: string
  onClick?: () => void
}

interface UICardProps {
  actions?: UICardAction[]
  className?: string
  contentStyle?: React.CSSProperties
  style?: React.CSSProperties
  title?: string
  buttonColor?: ButtonColorChoices
}

const UiCard: React.FC<UICardProps> = props => {
  const {
    actions,
    children,
    className,
    contentStyle,
    style,
    title,
    buttonColor,
  } = props
  return (
    <div
      className={className ? `${styles.uiCard} ${className}` : styles.uiCard}
      style={style}
    >
      {title && (
        <div className={styles.uiCardHeader}>
          <Text type="largeBody">{`${title}`}</Text>
          {actions &&
            actions.map(action => (
              <Button
                key={action.id}
                id={action.id}
                title={action.title}
                buttonColor={buttonColor}
                onClick={action.onClick}
              />
            ))}
        </div>
      )}
      <div className={styles.uiCardContent} style={contentStyle}>
        {children}
      </div>
    </div>
  )
}

export default UiCard
